/**
 * Guards for async-thunk payloads landing in slice state.
 *
 * Our API responses are unwrapped as `response.data.body`, which is `undefined`
 * whenever an endpoint returns no body — and some thunks return an error string
 * instead of rejecting. Writing either straight into state produces a list
 * containing `undefined`, or a list that is not a list at all, and the crash
 * surfaces later in whichever component maps over it.
 *
 * Reducers should never widen the type of their own state. Use these at every
 * point where a payload enters a collection.
 */

/** True only for a plain object — the one thing safe to put in a list of records. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === 'object' && !Array.isArray(value);

/** Coerce a list payload to an array so consumers can always map over it. */
export const asArray = <T>(value: unknown): T[] => (Array.isArray(value) ? value : []);
